/*
 * @Author: your name
 * @Date: 2021-08-05 14:05:50
 * @LastEditTime: 2021-08-05 14:05:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /cloud-recruit/src/utils/antd/index.js
 */
export notification from './notification';


// WEBPACK FOOTER //
// ./src/utils/antd/index.js